<template>
  <div class="result-container">
    <div class="container">
      <img src="@/assets/images/icon-success.png" class="icon" />
      <p class="success-text">提交成功</p>
      <p class="success-tips">
        信息提交成功，我们的专职人员将很快与您联系，请耐心等待
      </p>
      <div @click="onBack" class="back-btn">返回首页 →</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onBack() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>
<style lang="scss" scoped>
.result-container {
  width: 100vw;
  display: flex;
  justify-content: center;
  .container {
    height: 800px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    .icon {
      width: 92px;
      height: 92px;
    }
    .success-text {
      color: #000000;
      font-size: 26px;
      margin-top: 35px;
    }
    .success-tips {
      color: #808080;
      font-size: 14px;
      margin-top: 25px;
    }
    .back-btn {
      margin-top: 66px;
      color: #666666;
      font-size: 15px;
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
}
</style>
